import { render, staticRenderFns } from "./UiDropdown.vue?vue&type=template&id=4c02582f&scoped=true"
import script from "./UiDropdown.vue?vue&type=script&lang=js"
export * from "./UiDropdown.vue?vue&type=script&lang=js"
import style0 from "./UiDropdown.vue?vue&type=style&index=0&id=4c02582f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c02582f",
  null
  
)

export default component.exports